import type { ButtonHTMLAttributes, ReactNode } from 'react'

type ActionProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'className'> & {
  children: ReactNode
  className?: string
}

function actionClass(kind: string, className?: string) {
  return ['swell-action', kind, className].filter(Boolean).join(' ')
}

/** Use for the one dominant action that completes or advances the current task. */
export function PrimaryAction({ children, className, type = 'button', ...props }: ActionProps) {
  return <button className={actionClass('swell-primary-action', className)} type={type} {...props}>{children}</button>
}

/** Use for secondary contextual actions such as Edit, Manage and Record. */
export function TextAction({ children, className, type = 'button', ...props }: ActionProps) {
  return <button className={actionClass('swell-text-action', className)} type={type} {...props}>{children}</button>
}

/** Use beside the content being added or linked. Keep the leading + in the label. */
export function InlineAction({ children, className, type = 'button', ...props }: ActionProps) {
  return <button className={actionClass('swell-inline-action', className)} type={type} {...props}>{children}</button>
}
